import { LandingContent } from "./types";

export const revenueAscentLanding: LandingContent = {
  ctaText: "Book a meeting with Sean",
  quickFacts: ["Member program", "12-month commitment", "Manager-friendly"],
  whyHeading: "Why teams use RevenueAscent",
  why: "Without reinforcement, training never compounds. Execution drifts, managers reset, and revenue depends on people instead of systems. RevenueAscent is a 12-month reinforcement program built specifically for CertainPath members who want coached behaviors to become standards that hold under real-world pressure. Coaching turns into behavior, performance becomes predictable, and the business scales beyond its top performers.",
  advantages: [
    {
      title: "Coaching turns into behavior",
      description:
        "What's discussed in coaching shows up consistently in the field. Teams practice the same standards, make the same decisions, and execute the same way — week after week.",
      includedNote: "Coaching behaviors become field standards",
    },
    {
      title: "Performance becomes predictable",
      description:
        "Results stop swinging based on who's working. Managers follow a clear inspection cadence, leaders gain visibility, and execution holds under pressure.",
      includedNote: "Predictable performance, week after week",
    },
    {
      title: "Scales beyond individuals",
      description:
        "Revenue no longer depends on a few top performers. Systems replace heroics, allowing growth without constant resets or increased owner involvement.",
      includedNote: "Managers inherit a clear inspection cadence",
    },
  ],
  featureChecklist: [
    "Coaching behaviors become field standards",
    "Predictable performance, week after week",
    "Managers inherit a clear inspection cadence",
    "Revenue stops depending on top performers",
  ],
  highlights: [
    {
      title: "A 3-step path to commit",
      description:
        "Step 1: Contact Sean. Step 2: Determine fit. Step 3: Earn the rewards of permanent change. Intentionally simple to begin, rigorous to sustain.",
    },
  ],
  steps: [
    {
      title: "Step 1 · Contact Sean",
      description:
        "Start the conversation to understand how RevenueAscent works and what reinforcement looks like in practice.",
    },
    {
      title: "Step 2 · Determine fit",
      description:
        "Work with Sean to determine whether RevenueAscent is the right reinforcement system for your team, based on goals, structure, and readiness.",
    },
    {
      title: "Step 3 · Run the 12-month rhythm",
      description:
        "Monthly reinforcement shows up in the field. Coached behaviors become standards your managers inspect every week.",
    },
    {
      title: "Step 4 · Earn permanent change",
      description:
        "With reinforcement in place, behaviors stick, execution stabilizes, and performance becomes system-driven, not person-dependent.",
    },
  ],
  testimonials: [
    {
      quote:
        "Sean doesn't teach theory — he reinforces behavior until it holds under pressure. Six months in, our advisors make the same decisions whether I'm in the office or not.",
      initials: "SM",
      name: "Sean Mitchell",
      attribution: "RevenueAscent Coach · CertainPath",
      stats: [
        { label: "HVAC sold (1 yr)", value: "$8.7M" },
        { label: "Co. growth driven", value: "$12M→$22M" },
      ],
    },
  ],
  faqs: [
    {
      question: "Who is RevenueAscent for?",
      answer:
        "CertainPath members ready to move from coaching conversations to consistent execution. It's most powerful for owners, GMs, and managers leading sales advisors and technicians.",
    },
    {
      question: "What does a typical month look like?",
      answer:
        "A monthly group session with Sean, a defined reinforcement focus for the month, and weekly inspection rhythms your managers run with their teams.",
    },
    {
      question: "Why reinforcement instead of more training?",
      answer:
        "Training without reinforcement decays in weeks. Reinforcement turns the same behaviors into standards that hold under real-world pressure.",
    },
    {
      question: "Is this in-person or virtual?",
      answer:
        "Virtual monthly sessions, with optional in-person workshops. The Leader Guide travels with you for in-truck and shop-floor application.",
    },
  ],
  closing: {
    heading: "Make execution stick",
    body: "Book a fit call with Sean and see whether RevenueAscent is the right reinforcement system for your team.",
  },
};
